export default __webpack_public_path__ + "static/media/7UT513.0bc67f96.jpg";